import { render, staticRenderFns } from "./SCardPaymentCloseBoxComp.vue?vue&type=template&id=43c38a55&"
import script from "./SCardPaymentCloseBoxComp.vue?vue&type=script&lang=js&"
export * from "./SCardPaymentCloseBoxComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports